import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle, useMemo } from 'react'
import { AgGridReact } from 'ag-grid-react';
import '../../../../../styles/ag-custom.css';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import axios from '@fuse/utils/axios';
import { useRouter } from '@fuse/hooks';
import { getLocalTimeFromUTC } from '@fuse/utils/dateOperations';
import FuseLoading from '@fuse/core/FuseLoading';

const Activities = forwardRef(({ serviceRequestId }, ref) => {
  const gridRef = useRef();
  const router = useRouter();
  const id = router.params.id ?? serviceRequestId;

  const [windowHeight, setWindowHeight] = useState(window.innerHeight - 430);
  const [rowData1, setRowData1] = useState(null);
  const [loading, setLoading] = useState(false);

  const tableHeaders1 = [
    {
      field: "action_id",
      headerName: "Action Id",
      minWidth: 150,
      headerComponent: CustomFilter
    },
    {
      field: "ticket_id",
      headerName: "Ticket Id",
      minWidth: 150,
      headerComponent: CustomFilter
    },
    {
      field: "action_date_and_time",
      headerName: "Action date and time",
      minWidth: 250,
      headerComponent: CustomFilter
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 150,
      headerComponent: CustomFilter
    },
    {
      field: "field_name",
      headerName: "Field Name",
      minWidth: 150,
      headerComponent: CustomFilter
    },
    {
      field: "previous_value",
      headerName: "Previous value",
      minWidth: 150,
      headerComponent: CustomFilter
    },
    {
      field: "current_value",
      headerName: "Current value",
      minWidth: 150,
      headerComponent: CustomFilter
    },
    {
      field: 'name',
      headerName: 'Name',
      minWidth: 150,
      headerComponent: CustomFilter
    },
    {
      field: 'description',
      headerName: 'Description',
      minWidth: 150,
      headerComponent: CustomFilter
    },
    {
      field: 'user_role',
      headerName: 'User Role',
      minWidth: 150,
      headerComponent: CustomFilter
    }
  ];

  const action_to_color = {
    "CREATED": "green",
    "UPDATED": "orange",
    "ARCHIVED": "red",
    "RESTORED": "blue",
    'DELETED': "red"
  }
  function formatLogs(data) {
    let { length } = data
    return data.map((item) => {
      const obj = {
        id: item.id,
        action_id: `act${length}`,
        action_date_and_time: item.created_at,
        ticket_id: item.service_request ? item.service_request.ticket_id : item.ticket_id,
        name: item.user_name,
        action: item.action_name,
        description: item.comment,
        previous_value: item.previous_data,
        current_value: item.current_data,
        field_name: item.action_field_name,
        user_role: item.user_role_name,
        asset_serial_number: item.asset_serial_number || 'N/A'
      }
      length--;
      return obj
    })
  }

  const onGridReady = params => {
    // Following line to make the currently visible columns fit the screen  
    params.api.sizeColumnsToFit();

    // Following line dynamic set height to row on content
    params.api.resetRowHeights();
  };

  function cellRenderer(params) {
    if (params.colDef.field === "action") {
      return (
        <span style={{
          color: action_to_color[params.value],
          fontWeight: 'bold'
        }}>{params.value}</span>
      )
    } if (params.colDef.field === 'description') {
      return (
        <span
          style={{
            wordBreak: 'break-word'
          }}
        >{params.value}</span>
      )
    }
    return (
      <>{params.value}</>
    )

  }

  function fetchActivities() {
    setLoading(true)
    axios.get(`/service/fetch-service-request-activities/${id}`).then((res) => {
      setRowData1(formatLogs(res.data.data.activities))
    }).catch((err) => {
      console.log(err)
    }).finally(() => setLoading(false))
  }

  useImperativeHandle(ref, () => ({ fetchActivities }));

  useEffect(() => {
    fetchActivities()
  }, []);

  const columnDefs = useMemo(() => {
    return tableHeaders1.map((header) => {
      if (header.field === "action_date_and_time") {
        return {
          field: header.field,
          headerName: header.headerName,
          width: header.width,
          minWidth: header.minWidth,
          maxWidth: header.maxWidth,
          sortable: false,
          flex: 1,
          filter: "agTextColumnFilter",
          wrapText: true,
          cellRenderer: (params) =>
            !params.value ? params.value : getLocalTimeFromUTC(params.value),
          headerComponent: (props) => CustomFilter(props, header, gridRef),
        };
      }

      return {
        field: header.field,
        headerName: header.headerName,
        width: header.width,
        minWidth: header.minWidth,
        maxWidth: header.maxWidth,
        sortable: false,
        flex: 1,
        filter: "agTextColumnFilter",
        wrapText: true,
        autoHeight: header.field === "description",
        cellRenderer,
        headerComponent: (props) => CustomFilter(props, header, gridRef),
      };
    });
  }, [tableHeaders1, gridRef, getLocalTimeFromUTC, CustomFilter, cellRenderer]);


  return (
    <>
      <div
        className="ag-theme-alpine"
        style={{
          width: "100%",
          height: windowHeight + 105,
          fontSize: '12px'
        }}
      >
        {rowData1 === null ? (
          <FuseLoading />
        ) : (
          <AgGridReact
            ref={gridRef}
            theme="legacy"
            rowData={rowData1}
            animateRows
            onGridReady={onGridReady}
            paginationPageSize={10}
              paginationPageSizeSelector={[10, 20, 50, 100]}
              rowHeight={30}
              headerHeight={44}
            pagination
            defaultColDef={{
              resizable: true
            }}
              columnDefs={columnDefs}
            />
        )}
      </div>
    </>
  )
})

export default Activities